import React, { useRef } from 'react';
import CustomerSearch from './CustomerSearch';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import customerRoutes from "../../Constants/Customer/customerRoutes";

export default function TopNavigationSearch() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const searchRef = useRef(null);

    const handleCustomerSelect = (customer) => {
        navigate(customerRoutes.customer(customer.pathId));
        searchRef.current?.clear();
    }

    const handleBlur = () => {
        searchRef.current?.clear();
    }

    return (
        <li className="w-100 skynet-icon-search navbar-form" role="search">
            <CustomerSearch 
                ref={searchRef}
                id="topnavigationsearch" 
                onChange={handleCustomerSelect} 
                placeholder={t("topnavigation.searchFieldPlaceHolder")}
                onBlur={handleBlur}
            />
        </li>
    );
}
